module.exports = __webpack_public_path__ + "img/upstairs1.56f024e9.jpg";